import { Grid, Table } from 'antd';
import { ColumnType, TablePaginationConfig } from 'antd/es/table';
import { RecordCountBadge } from 'components';
import { StyledTableHeader, StyledTableWrapper } from 'components/table/table.styled';
import { useUserContext } from 'features/users';
import { getPermission } from 'routes/utils';
// import { EventsFilterFormPaginated } from 'features/events';
// import { Dispatch, SetStateAction } from 'react';
// import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';

const { useBreakpoint } = Grid;

// type EventsTableProps = {
//     isLoading: boolean;
//     data?: any;
//     tableParams: EventsFilterFormPaginated;
//     updateParams: Dispatch<SetStateAction<EventsFilterFormPaginated>>;
//     refetch: any
// };




const UploadDetailsComponentTable = ({
    data,
    isLoading,
    tableParams,
    updateParams,
    // refetch
}: any) => {
    const handleTableChange = (
        pagination: TablePaginationConfig,
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
        });
    };
    const screens = useBreakpoint();
    const tableWidth = screens.xxl ? { x: 1440 } : { x: 1200 };

    const participants = data?.items?.[0]?.ParticipantList_new || [];
    const participantList = data?.items?.[0]?.ParticipantList_new || [];
    const paymentStatus = data?.items?.[0]?.bulk_upload_details?.payment_Status;

    const { user } = useUserContext();
  const GroupRegistrationPerm = getPermission(user, "group_registration");
  const IsShowEmail = GroupRegistrationPerm?.showEmail;
  const IsShowPhoneNumber = GroupRegistrationPerm?.showMobile;

    // const onDelete = (id: any) => {
    //     try {
    //         const apires: any = TransectionApiServices().removeParticipantlist(id)
    //         message.success(apires?.ResponseMessage)
    //         refetch()
    //     } catch (error: any) {
    //         message.error(error)
    //     }
    // }

    // 🔹 Dynamically generate all data columns
    const dynamicColumns: ColumnType<any>[] = participants.length
        ? Object.keys(participants[0]).map((key) => ({
            title: key,
            dataIndex: key,
            key: key,
            ellipsis: true,
            width: 200,
            render: (text: any) => {
                if (key.toLowerCase() === "email") {
                     return IsShowEmail ? text : "************";
                    }

                if (key.toLowerCase() === "phone") {
                     return IsShowPhoneNumber ? text : "************";
                    }
    
                return  text ?? "-";
            }
        }))
        : [];

    

  
    const columnsWithAction =
        paymentStatus === "SUCCESS" || participantList.length === 0
            ? dynamicColumns
            : [...dynamicColumns];


    return (
        <div>
            <StyledTableWrapper>
                <StyledTableHeader>
                    <RecordCountBadge
                        text="Participants found"
                        count={data?.items?.[0]?.ParticipantList_new?.length ?? 0}
                    />
                </StyledTableHeader>

                <Table
                    loading={isLoading}
                    dataSource={participants}
                    rowKey="ParticipantId"
                    onChange={handleTableChange}
                    pagination={{
                        current: tableParams.page,
                        defaultPageSize: tableParams.size,
                        total: data?.total,
                    }}
                    className="event_table"
                    scroll={{ ...tableWidth, x: true }}
                    columns={columnsWithAction}
                />
            </StyledTableWrapper>
        </div>
    );
};

export default UploadDetailsComponentTable;
